// extracted by mini-css-extract-plugin
export default {"radio":"HVRadio_module-SPCH6U2J_radio__P8IlN","icon":"HVRadio_module-SPCH6U2J_icon__HOdgd","label":"HVRadio_module-SPCH6U2J_label__BVzEn"};